import { RefObject, useEffect } from 'react';

type Params<
  ContainerRef extends HTMLElement = HTMLElement,
  ItemRef extends HTMLElement = HTMLElement,
  Dependency = unknown
> = {
  containerRef: RefObject<ContainerRef | null>;
  itemRef: RefObject<ItemRef | null>;
  dependency?: Dependency;
};

export const useHorizontalScrollToElement = ({ containerRef, itemRef, dependency }: Params) => {
  useEffect(() => {
    if (containerRef.current && itemRef.current) {
      const container = containerRef.current;
      const item = itemRef.current;

      const navLeft = container.getBoundingClientRect().left;
      const itemLeft = item.getBoundingClientRect().left;

      const scrollLeftPosition = itemLeft - navLeft + container.scrollLeft;

      container.scrollLeft = scrollLeftPosition - container.offsetWidth / 2 + item.offsetWidth / 2;
    }
  }, [containerRef, itemRef, dependency]);
};
